<template>
    <v-container>
      <h1 class="text-h4 mb-4">Duyuruyu Düzenle</h1>
  
      <v-row v-if="loadingInitial" justify="center" class="mt-10">
         <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
         <p class="mt-2 text-center">Duyuru bilgileri yükleniyor...</p>
       </v-row>
  
      <v-row v-else-if="error">
          <v-col cols="12">
              <v-alert type="error" prominent>
                  {{ error }}
                  <v-btn @click="fetchAnnouncementData" small class="ml-4">Tekrar Dene</v-btn>
              </v-alert>
          </v-col>
       </v-row>
  
      <v-card v-else>
        <v-card-text>
           <v-alert v-if="submitError" type="error" dense dismissible class="mb-4">
             {{ submitError }}
          </v-alert>
          <v-form @submit.prevent="handleSubmit" ref="announcementForm">
             <v-text-field v-model="formData.title" label="Başlık" :rules="[rules.required]" counter="100" class="mb-3" variant="outlined"></v-text-field>
             <v-textarea v-model="formData.description" label="Açıklama" :rules="[rules.required]" rows="5" auto-grow class="mb-3" variant="outlined"></v-textarea>
             <v-text-field v-model="formData.price" label="Fiyat (Opsiyonel)" type="number" prefix="₺" :rules="[rules.numeric]" clearable class="mb-3" variant="outlined"></v-text-field>
             <v-text-field v-model="formData.location" label="Konum (Opsiyonel)" class="mb-3" variant="outlined"></v-text-field>
             <v-text-field v-model="formData.contact_info" label="İletişim Bilgisi (Opsiyonel)" class="mb-3" variant="outlined"></v-text-field>
  
             <v-divider class="my-4"></v-divider>
  
             <div v-if="existingImages.length > 0">
                 <h3 class="text-subtitle-1 mb-2">Mevcut Resimler</h3>
                 <v-row>
                     <v-col v-for="(image, index) in existingImages" :key="image.id" cols="6" sm="4" md="3" lg="2">
                          <v-card elevation="2" :class="{ 'image-marked-for-deletion': isMarkedForDeletion(image.id) }">
                              <v-img :src="getImageUrl(image.url)" aspect-ratio="1" class="grey lighten-2" cover>
                                   <v-btn
                                      v-if="!isMarkedForDeletion(image.id)"
                                      icon="mdi-delete-forever"
                                      size="x-small"
                                      color="red-darken-1"
                                      class="ma-1"
                                      style="position: absolute; top: 0; right: 0;"
                                      @click="markImageForDeletion(image.id, index)"
                                      title="Bu resmi sil"
                                  ></v-btn>
                                   <v-btn
                                      v-else
                                      icon="mdi-undo-variant"
                                      size="x-small"
                                      color="orange-darken-1"
                                      class="ma-1"
                                      style="position: absolute; top: 0; right: 0;"
                                      @click="unmarkImageForDeletion(image.id, index)"
                                      title="Silme işlemini geri al"
                                  ></v-btn>
                              </v-img>
                          </v-card>
                     </v-col>
                 </v-row>
             </div>
              <p v-else class="text-caption grey--text mb-3">Mevcut resim yok.</p>
  
  
             <h3 class="text-subtitle-1 mt-6 mb-2">Yeni Resim Ekle</h3>
               <v-file-input
                  v-model="transientImageFiles"
                  @update:modelValue="handleFileChange"
                  label="Resim Seç (Maks 5 - Toplam)"
                  multiple
                  chips
                  show-size
                  accept="image/*"
                  prepend-icon="mdi-camera-plus"
                  :rules="[rules.maxTotalImages]" class="mb-3"
                  variant="outlined"
                  clearable
                  @click:clear="clearNewFileInput"
              ></v-file-input>
  
              <v-row v-if="newImagePreviews.length > 0">
                  <v-col v-for="(preview, index) in newImagePreviews" :key="preview.name + index" cols="6" sm="4" md="3" lg="2">
                       <v-card elevation="2">
                           <v-img :src="preview.src" aspect-ratio="1" class="grey lighten-2" cover>
                               <v-btn
                                  icon="mdi-close"
                                  size="x-small"
                                  color="red"
                                  class="ma-1"
                                  style="position: absolute; top: 0; right: 0;"
                                  @click="removeNewImage(index)"
                                  title="Bu yeni resmi kaldır"
                              ></v-btn>
                           </v-img>
                           <v-card-text class="pa-1 text-caption text-truncate" style="font-size: 0.7rem !important;">
                               {{ preview.name }}
                           </v-card-text>
                      </v-card>
                  </v-col>
              </v-row>
  
  
             <v-divider class="my-4"></v-divider>
  
             <v-btn
               type="submit"
               color="success"
               large
               :loading="loadingSubmit"
               :disabled="loadingSubmit"
             >
               Değişiklikleri Kaydet
             </v-btn>
             <v-btn text :to="{ name: 'AnnouncementDetail', params: { id: this.id } }" class="ml-2">İptal</v-btn>
  
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import announcementService from '@/services/announcementService';
  
  export default {
    name: 'AnnouncementEdit',
    props: {
      id: { type: [String, Number], required: true }
    },
    data() {
      return {
        loadingInitial: false,
        loadingSubmit: false,
        error: null,
        submitError: null,
        formData: {
          title: '', description: '', price: null, location: '', contact_info: '',
        },
        existingImages: [],       // Mevcut resimler { id, url }
        imagesToDelete: [],       // Silinecek mevcut resimlerin ID'leri
        transientImageFiles: [],  // v-file-input geçici modeli
        newlySelectedFiles: [], // Yeni eklenen dosyalar (File objeleri)
        newImagePreviews: [],     // Yeni resimlerin önizlemesi { src, name }
        maxFilesTotal: 5,         // Toplam maksimum resim sayısı
        rules: {
          required: value => !!value || 'Bu alan zorunludur.',
          numeric: value => (!value || value === '' || !isNaN(parseFloat(value))) || 'Sayısal bir değer veya boş olmalı.',
          // Toplam resim sayısı kontrolü
          maxTotalImages: () => (this.existingImages.length - this.imagesToDelete.length + this.newlySelectedFiles.length) <= this.maxFilesTotal || `Toplam resim sayısı ${this.maxFilesTotal} adedi geçemez.`
        },
      };
    },
    methods: {
      async fetchAnnouncementData() {
        this.loadingInitial = true; this.error = null; this.imagesToDelete = []; // Temizle
        try {
          const response = await announcementService.getAnnouncement(this.id);
          const d = response.data;
          this.formData = { title: d.title || '', description: d.description || '', price: d.price, location: d.location || '', contact_info: d.contact_info || '' };
          this.existingImages = d.images || [];
        } catch (err) { /* ... Hata yönetimi ... */ }
        finally { this.loadingInitial = false; }
      },
  
      // --- Yeni Resim Ekleme/Çıkarma ---
      handleFileChange(newFiles) {
          if (!newFiles || newFiles.length === 0) { this.transientImageFiles = []; return; }
          newFiles.forEach(file => {
              const currentTotal = this.existingImages.length - this.imagesToDelete.length + this.newlySelectedFiles.length;
              if (currentTotal < this.maxFilesTotal) {
                  this.newlySelectedFiles.push(file);
              } else { console.warn(`Limit ${this.maxFilesTotal} aşıldı.`); }
          });
          this.updateNewImagePreviews();
          this.$nextTick(() => { this.transientImageFiles = []; });
           // Formu tekrar doğrula (resim sayısı kuralı için)
          this.$refs.announcementForm?.validate();
      },
      updateNewImagePreviews() {
          this.newImagePreviews = [];
          this.newlySelectedFiles.forEach(file => {
              const reader = new FileReader();
              reader.onload = (e) => this.newImagePreviews.push({ src: e.target.result, name: file.name });
              reader.readAsDataURL(file);
          });
      },
       removeNewImage(indexToRemove) {
          if (indexToRemove >= 0 && indexToRemove < this.newlySelectedFiles.length) {
              this.newlySelectedFiles.splice(indexToRemove, 1);
              this.updateNewImagePreviews();
               // Formu tekrar doğrula
              this.$refs.announcementForm?.validate();
          }
      },
       clearNewFileInput() {
          this.transientImageFiles = []; // Modeli temizle
       },
  
      // --- Mevcut Resimleri Silme İşlemleri ---
      markImageForDeletion(imageId) {
          if (!this.imagesToDelete.includes(imageId)) {
              this.imagesToDelete.push(imageId);
               // Formu tekrar doğrula
               this.$nextTick(() => { this.$refs.announcementForm?.validate(); });
          }
          // Görsel olarak işaretlemek için sadece class yeterli, listeden çıkarmaya gerek yok
      },
       unmarkImageForDeletion(imageId) {
           const idx = this.imagesToDelete.indexOf(imageId);
           if (idx > -1) {
               this.imagesToDelete.splice(idx, 1);
                // Formu tekrar doğrula
               this.$nextTick(() => { this.$refs.announcementForm?.validate(); });
           }
       },
        isMarkedForDeletion(imageId) {
           return this.imagesToDelete.includes(imageId);
        },
  
      // --- Kaydetme İşlemi ---
      async handleSubmit() {
        this.submitError = null;
        if (!this.$refs.announcementForm) return;
        const { valid } = await this.$refs.announcementForm.validate();
        if (!valid) return;
         // Toplam resim sayısını son kez kontrol et
         if ((this.existingImages.length - this.imagesToDelete.length + this.newlySelectedFiles.length) > this.maxFilesTotal) {
             this.submitError = `Toplam resim sayısı ${this.maxFilesTotal} adedi geçemez.`;
             return;
         }
  
        this.loadingSubmit = true;
        try {
          // Adım 1: Metin verilerini güncelle
          const updateData = { ...this.formData };
          if (updateData.price === '') updateData.price = null;
          else if (updateData.price !== null) updateData.price = parseFloat(updateData.price);
          await announcementService.updateAnnouncement(this.id, updateData);
  
          // Adım 2: Silinecek resimleri sil (Promise.all ile paralel yapılabilir)
          const deletePromises = this.imagesToDelete.map(imgId =>
              announcementService.deleteImage(this.id, imgId)
          );
          await Promise.all(deletePromises); // Hataları yakalamak için Promise.allSettled daha iyi olabilir
  
          // Adım 3: Yeni resimleri yükle
          if (this.newlySelectedFiles.length > 0) {
            const imageFormData = new FormData();
            this.newlySelectedFiles.forEach(file => {
              imageFormData.append('images', file);
            });
            await announcementService.uploadImages(this.id, imageFormData);
          }
  
          // Başarılı, detay sayfasına yönlendir
          this.$router.push({ name: 'AnnouncementDetail', params: { id: this.id } });
          // TODO: Başarı mesajı
  
        } catch (err) {
          this.submitError = err.response?.data?.message || 'Duyuru güncellenirken bir hata oluştu.';
          console.error("Submit Update Error:", err);
           // TODO: Kullanıcıya daha detaylı hata bilgisi verilebilir (hangi adımda hata olduğu vb.)
        } finally {
          this.loadingSubmit = false;
        }
      },
      // Resim URL'lerini düzeltme (önceki gibi)
       getImageUrl(url) {
          const backendBaseUrl = (process.env.VUE_APP_API_BASE_URL || 'http://localhost:5001/api').replace('/api','');
          if (!url) return 'https://via.placeholder.com/150?text=ResimYok';
           if (url.startsWith('http') || url.startsWith('/')) {
                if(url.startsWith('/') && !url.startsWith('//')) { return `${backendBaseUrl}${url}`; }
                return url;
           }
           return `${backendBaseUrl}/${url}`;
       },
    },
    created() {
      this.fetchAnnouncementData();
    }
  };
  </script>
  
  <style scoped>
  .image-marked-for-deletion {
      opacity: 0.5;
      border: 2px dashed orange;
  }
  </style>